<div class="image">
    <div class=outer>
        <div class="middle">
            <div class="inner">
                <div class="logo">
                </div>
                <div class="action">
                    <button mat-raised-button style="background-color: cornflowerblue;" (click)="login()">{{"global.Connect" | translate}}</button>
                </div>      
            </div>
        </div>
    </div>


</div>
